import Loader from 'components/Loader'
import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'
import LoaderTerpel from 'components/LoaderTerpel/LoaderTerpel'

const Integrations = lazy(() => import('./Integrations/Integrations'))


const Monitor = ({ match }:any) => {
  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<LoaderTerpel />}>
          <Route path={`${match.url}/monitor-bold`} component={Integrations} />
         
        </Suspense>
      </Switch>
    </div>
  )
}

export default Monitor
